import { AccountTypeView, MarketView, UserView } from '@api-proxies';
import {
    IAdditionalFiltersConfig,
    IGenericAdditionalFilters
} from '@shared/additional-filters/additional-filters.config';

export const ACCOUNTS_FILTER_KEY = 'accounts';

export interface IFilterValueAccounts {
    searchText?: string;
    accountType?: AccountTypeView;
    market?: MarketView;
    includeArchived?: boolean;
    sortBy?: string;
    sortDirection?: string;
    salespersons?: UserView[];
}

export interface IAdditionalFiltersAccounts extends IGenericAdditionalFilters {
    accountType?: AccountTypeView[];
    market?: MarketView[];
    salespersons?: UserView[];
    includeArchived?: boolean;
}

export const ACCOUNTS_FILTER_CONFIG: IAdditionalFiltersConfig<IAdditionalFiltersAccounts> = {
    entityType: 'accounts',

    visibility: {
        accountType: true,
        market: true,
        salesperson: true,
        includeArchived: true
    },

    transformToFilters: (formValue: any): IAdditionalFiltersAccounts => {
        return {
            accountType:
                formValue.accountType && formValue.accountType.length > 0 ? formValue.accountType[0] : undefined,
            market: formValue.market && formValue.market.length > 0 ? formValue.market[0] : undefined,
            salespersons:
                formValue.salespersons && formValue.salespersons.length > 0 ? formValue.salespersons : undefined,
            includeArchived: formValue.includeArchived || undefined
        };
    },

    transformFromFilters: (filters: IAdditionalFiltersAccounts): any => {
        return {
            accountType: filters?.accountType ? [filters.accountType] : [],
            market: filters?.market ? [filters.market] : [],
            salespersons: filters?.salespersons || [],
            includeArchived: filters?.includeArchived || undefined
        };
    },

    hasFiltersApplied: (filters: IAdditionalFiltersAccounts | null): boolean => {
        if (!filters) return false;
        const props = ['market', 'salespersons', 'accountType'];
        if (props.some((prop) => filters[prop])) return true;
        return filters.includeArchived === true;
    }
};
